import request from '@/plugin/axios'

export function page(query) {
return request({
url: '/api/admin/sysFormThunder/page',
method: 'get',
params: query
})
}

export function addObj(obj) {
return request({
url: '/api/admin/sysFormThunder/saveOrUpdate',
method: 'post',
data: obj
})
}

export function getObj(id) {
return request({
url: '/api/admin/sysFormThunder/' + id,
method: 'get'
})
}

export function delObj(id) {
return request({
url: '/api/admin/sysFormThunder/' + id,
method: 'delete'
})
}

export function putObj(id, obj) {
return request({
url: '/api/admin/sysFormThunder/' + id,
method: 'put',
data: obj
})
}
